module.exports = [
    {
        id: 1,
        category: 1,
        location: "Tennessee, U.S.",
        title: 'Uranium Processing Facility',
        teaser: "Bechtel is constructing a new facility at the Y-12 National Security Complex to ensure the long-term viability, safety, and security of enriched uranium capabilities in the U.S. The modernization will fortify the country's nuclear defense, reduce global threats from weapons of mass destruction, improve worker safety, reduce energy consumption, and significantly lower operating and maintenance costs."
    },
    {
        id: 2,
        category: 1,
        location: "Devonport, U.K.",
        title: 'Devonport',
        teaser: "As part of an ongoing infrastructure investment program at Babcock International’s Devonport facility, Bechtel is acting as delivery partner to Devonport Royal Dockyard Limited as it upgrades dock infrastructure. Babcock’s Devonport facility is co-located with HM Naval Base Devonport and forms the largest naval support site in Western Europe."
    },
    {
        id: 3,
        category: 1,
        location: "Florida, U.S.",
        title: 'Mobile Launcher 2',
        teaser: "NASA is committed to landing the first woman and the first person of color on the moon by 2026, and Bechtel is partnering in this mission by constructing Mobile Launcher 2 (ML2). ML2 will be used to safely assemble and process NASA’s Space Launch System (SLS) 1B Rocket and Orion Spacecraft, support the launch vehicle during transport, and support launches to the moon and eventually Mars."
    },
    {
        id: 4,
        category: 1,
        location: "Tennessee, Maryland, and California, U.S.",
        title: 'Arnold Engineering Development Complex',
        teaser: "Bechtel is delivering a hypersonic test facility at the U.S. Air Force’s AEDC. AEDC is the most advanced and largest complex of flight simulation test facilities in the world, performing work for the U.S. Department of Defense, Army, Navy, and Air Force, NASA,  both domestic and foreign private industry, allied foreign governments, and educational institutions."
    },
    {
        id: 5,
        category: 1,
        location: "Colorado and Kentucky, U.S.",
        title: 'Blue Grass & Pueblo Chemical Agent-Destruction Plants',
        teaser: "A Bechtel-led team safely destroyed the U.S.’s chemical weapons stockpile at these Bechtel-built-and-operated facilities, which held over 3,000 tons of chemical agents in artillery projectiles, mortar rounds, and M55 rockets. Both facilities began final campaigns in 2022 to support national commitments under the 1997 Chemical Weapons Convention to meet the September 2023 completion deadline."
    },
    {
        id: 6,
        category: 1,
        location: "U.S.",
        title: 'Sentinel (Ground-Based Strategic Deterrent, GBSD)',
        teaser: "Bechtel is supporting the U.S. Air Force’s mission to modernize the country’s aging intercontinental ballistic missile systems by designing and constructing the launch infrastructure for the U.S.’s GBSD."
    },
    {
        id: 7,
        category: 1,
        location: "California, U.S.",
        title: 'Lawrence Livermore U.S. National Laboratory',
        teaser: "Since 2007, Bechtel has managed the Lawrence Livermore U.S. National Laboratory (LLNL). In 2022, LLNL scientists achieved a breakthrough in fusion research and contributed to NASA’s successful Double Asteroid Redirection Test for planetary defense. The team also completed the Exascale Computing Facility, enabling it to power the National Nuclear Security Administration’s first Exascale system."
    },
    {
        id: 8,
        category: 1,
        location: "Texas, U.S.",
        title: 'Pantex Plant',
        teaser: "Consolidated Nuclear Security, a Bechtel-led partnership, operates the Department of Energy’s Pantex Plant, supporting the safety, security, and effectiveness of U.S. nuclear defense capabilities. For decades, Pantex has provided technology for the manufacturing, evaluation, and testing of nuclear explosives, joint test beds, and other special nuclear materials."
    },
    {
        id: 9,
        category: 2,
        location: "Foynes, Ireland",
        title: 'Shannon Foynes Port Masterplan',
        teaser: "The Shannon Foynes Port Company in Ireland released its revised master plan developed by Bechtel. The master plan is a roadmap to develop the port to support the floating offshore wind sector, which could deliver six times Ireland’s domestic energy demand by 2050, help the country reach its climate goals, and produce electricity and eFuels for domestic use and exports."
    },
    {
        id: 10,
        category: 2,
        location: "Hsinchu, Taiwan",
        title: 'Hsin Tao Power Station',
        teaser: "Bechtel is helping Taiwan achieve greater energy security by studying the potential rebuild of the Hsin Tao Power Station to prevent future blackouts amid a large uptick in energy demand. Hsin Tao plays a key role in meeting existing energy needs as the country aims to obtain 50% of its energy from natural gas and 20% from renewables by 2025, while building an additional 13 gigawatts of capacity over the next 10 years."
    },
    {
        id: 11,
        category: 2,
        location: "Louisiana, U.S.",
        title: 'Cameron LNG Train 4',
        teaser: "Sempra Infrastructure selected Bechtel to conduct the front-end engineering design for the fourth LNG train at Cameron LNG’s converted export facility, which will increase the facility’s total LNG production from 12 to 18 million metric tons per year. It will also include design enhancements to reduce the facility’s emissions, using electric drive (E-drive) motors to replace gas turbine drives, and tie-ins to allow the potential for carbon sequestration."
    },
    {
        id: 12,
        category: 2,
        location: "Louisiana, U.S.",
        title: 'Lake Charles Liquefaction',
        teaser: "Energy Transfer chose Bechtel to perform the front-end engineering design verification to convert Lake Charles Liquefaction’s LNG import facility into an export facility and build three LNG trains with a total capacity of 16 million metric tons per year. The technology proposed for the project is designed to make it one of the most efficient and cleanest operating LNG facilities in the U.S."
    },
    {
        id: 13,
        category: 2,
        location: "Africa",
        title: 'CWP Global Green Hydrogen Facilities',
        teaser: "CWP Global partnered with Bechtel Energy Technologies & Solutions to develop conceptual and early planning solutions for large-scale green hydrogen and ammonia facilities in Africa."
    },
    {
        id: 14,
        category: 2,
        location: "U.S.",
        title: 'H Cycle Low-Carbon Hydrogen Program',
        teaser: "H Cycle selected Bechtel to support the development of a series of hydrogen plants across the U.S. to meet increased demand for low-carbon hydrogen using a technology that extracts hydrogen from municipal waste using heat and electricity."
    },
    {
        id: 15,
        category: 2,
        location: "Oaxaca, Mexico",
        title: 'Salina Cruz Refinery',
        teaser: "Pemex chose Bechtel Energy Technologies & Solutions’ ThruPlus® Delayed Coking technology to increase efficiency at its Salina Cruz refinery and expand its capacity by 75,000 barrels per day, supporting greater energy security in Mexico. The ThruPlus® technology now has more than 70 licensed units globally."
    },
    {
        id: 16,
        category: 2,
        location: "Karratha, Australia",
        title: 'Pluto Train 2',
        teaser: "Bechtel began construction on the Woodside Energy-operated Pluto LNG facility in 2022, after being selected to handle the full engineering, procurement, construction, commissioning, and start-up scopes of work to increase the facility’s capacity by another 5 million tonnes per annum. The facility will contribute to long-term economic growth and local employment opportunities for Western Australia."
    },
    {
        id: 17,
        category: 2,
        location: "Texas, U.S.",
        title: 'Port Arthur LNG Export Facility',
        teaser: "In 2022, Sempra Infrastructure gave Bechtel Limited Notice to Proceed on the Port Arthur LNG export facility, supporting global access to safe, sustainable, and reliable energy. The facility includes ancillary support facilities to liquefy and load LNG onto ships, as well as three LNG storage tanks, two marine berths, and two natural gas liquefaction trains producing up to 13.5 million metric tons per year."
    },
    {
        id: 18,
        category: 2,
        location: "Louisiana, U.S.",
        title: 'Driftwood LNG',
        teaser: "Tellurian gave Bechtel Limited Notice to Proceed for the Driftwood LNG export facility in 2022. Once complete, the facility’s export capacity will be nearly 28 million metric tons per year, helping to meet global LNG demand. The first phase will consist of two plants, each with up to four liquefaction trains, creating roughly 400 direct jobs and 6,500 construction jobs."
    },
    {
        id: 19,
        category: 2,
        location: "Texas, U.S.",
        title: 'Rio Grande LNG Facility',
        teaser: "NextDecade gave Bechtel Notice to Proceed on its Rio Grande LNG export facility, which will consist of three LNG trains, adding 18 million metric tons per year to global LNG capacity and two 180,000 cubic meter full containment tanks."
    },
    {
        id: 20,
        category: 2,
        location: "Texas, U.S.",
        title: 'HIF Global Matagorda eFuels Facility',
        teaser: "HIF Matagorda awarded Bechtel the front-end engineering design for its eFuels facility, which will produce carbon-neutral gasoline that can be used in vehicles without any modification to existing engines or infrastructure. The gasoline will be produced by utilizing CO2 captured from the atmosphere and green hydrogen from renewable power. By 2027, HIF USA expects the potential to decarbonize over 400,000 vehicles."
    },
    {
        id: 21,
        category: 2,
        location: "Texas, U.S.",
        title: 'Cutlass Solar 1 & 2',
        teaser: "Bechtel completed Cutlass Solar project Phase 1 and was awarded Cutlass Solar Phase 2, providing clean energy for thousands of homes. Phase 1 added 140 megawatts in the Houston area, enough to power 20,000 homes with zero-carbon electricity and eliminate 300,000 metric tons of CO2 emissions. Phase 2 will add another 218 megawatts of solar power through the installation of approximately 500,000 solar modules."
    },
    {
        id: 22,
        category: 2,
        location: "Idku, Egypt",
        title: 'Egyptian LNG Export Terminal Zero-Flaring Study',
        teaser: "A Bechtel-led coalition was selected to assess options to reduce methane emissions within the zero-flaring system at the Egyptian LNG (ELNG) export terminal. The project supports the Methane Global Pledge signed by Egypt in June 2022 and is part of a wider program aiming to decarbonize existing oil and gas facilities across the country and deliver on Egypt’s climate change strategy."
    },
    {
        id: 23,
        category: 2,
        location: "Idku, Egypt",
        title: 'Idku Energy Hub',
        teaser: "Shell Egypt, EGAS, and Petronas selected a Bechtel-led coalition to perform a front-end engineering and design study for a unified power system between the onshore gas processing plant of the West Delta Deep Marine gas fields and the Egyptian LNG export terminal in Idku."
    },
    {
        id: 27,
        category: 2,
        location: "Texas and Louisiana, U.S.",
        title: 'Corpus Christi and Sabine Pass Liquefaction Facilities',
        teaser: "Cheniere gave Bechtel Final Notice to Proceed for Stage 3 of the Corpus Christi LNG facility, and Bechtel completed the sixth production train at the Sabine Pass LNG facility. Both projects continue to add to U.S. LNG export capacity at a time when the focus on global energy security and energy transition is driving a growing role for natural gas as a lower-carbon alternative to coal."
    },
    {
        id: 28,
        category: 2,
        location: "Taichung, Taiwan",
        title: 'Taichung Phase III LNG Import Terminal Tanks',
        teaser: "CPC Corporation selected Bechtel to perform the full engineering, procurement, and construction scope of the LNG Tanks for the CPC Taichung Phase III LNG import terminal. The two 180,000 cubic meter fuel containment tanks will be the largest in Taiwan. CPC is rapidly expanding the country’s LNG import terminals to support the move from coal to natural gas as their primary transitional source of energy."
    },
    {
        id: 30,
        category: 3,
        location: "Sydney, Australia",
        title: 'Sydney Metro West',
        teaser: "Bechtel is delivering the driverless, underground Sydney Metro West, a once-in-a-century infrastructure investment for the Government of New South Wales. This landmark project will transform Sydney for generations to come, doubling rail capacity between Parramatta and the Sydney Central Business District, linking new communities to rail services, and supporting employment growth and housing supply."
    },
    {
        id: 31,
        category: 3,
        location: "Riyadh, Saudi Arabia",
        title: 'Riyadh Metro',
        teaser: "A Bechtel-led consortium is designing and building Lines 1 and 2 of Saudi Arabia’s first underground metro system. Continuing Bechtel’s 80-year legacy of working on major projects in Saudi Arabia, this critical infrastructure project will reduce traffic congestion, improve air quality, provide easier access to economic opportunities across the region, and support Riyadh as its population expands from 6 million to 8 million people by 2030."
    },
    {
        id: 32,
        category: 3,
        location: "U.K.",
        title: 'HS2 Phase 2B',
        teaser: "Bechtel is the development partner on HS2 as it moves the HS2 Phase 2B: High Speed Rail (Crewe-Manchester) Bill 2022 through the U.K. Parliament. Phase 2B will connect Crewe to Manchester."
    },
    {
        id: 33,
        category: 3,
        location: "Toronto, Canada",
        title: 'Ontario Line',
        teaser: "Bechtel continues to work as the delivery partner for Metrolinx’s rapid transit Ontario Line, which includes 15 new stations and will give Toronto residents a more reliable transit network by alleviating crowding and congestion. The project will make up to 47,000 jobs accessible in 45 minutes or less, take 28,000 cars off the road, and reduce fuel consumption by 7.2 million liters per year."
    },
    {
        id: 34,
        category: 3,
        location: "California, U.S.",
        title: 'Sepulveda Transit Corridor',
        teaser: "Bechtel is designing a high-capacity automated rail line in Los Angeles through one of the most congested corridors in the U.S. The project is one of two options under consideration to link the San Fernando Valley to the Westside (and eventually to Los Angeles International Airport), reducing the relentless traffic congestion on the 405 Freeway."
    },
    {
        id: 35,
        category: 3,
        location: "Tabuk Province, Saudi Arabia",
        title: 'NEOM The Spine & TROJENA',
        teaser: "Bechtel is providing project management consultancy services for NEOM, both the Spine transport infrastructure and regional infrastructure, including roads and water, as well as its iconic, year-round mountain destination, TROJENA. The Spine is the infrastructure corridor running below the Line, one of the new cities planned for the ambitious NEOM megaproject."
    },
    {
        id: 36,
        category: 3,
        location: "U.S.",
        title: 'First Student School Bus Electrification',
        teaser: "Bechtel is designing and building infrastructure to support electric vehicle charging for North America’s largest school bus operator, First Student, which is working to convert 30,000 of its school buses to run on electricity by 2035."
    },
    {
        id: 37,
        category: 3,
        location: "Sydney, Australia",
        title: 'Western Sydney Airport',
        teaser: "Bechtel is helping deliver this world-leading, full-service facility for international, domestic, and freight flights. Western Sydney International (Nancy-Bird Walton) Airport, which is being built using sustainable design elements to minimize its environmental impacts, will catalyze regional economic development, provide access to high-quality jobs, and create business opportunities for local communities."
    },
    {
        id: 38,
        category: 3,
        location: "London, U.K.",
        title: 'Elizabeth Line',
        teaser: "Bechtel supported the completion of Crossrail’s Elizabeth Line, which includes 10 newly built and 31 newly upgraded stations. The Elizabeth Line increased London’s rail capacity by 10% and brought an additional 1.5 million people within 45 minutes of central London, reducing journey times and transforming accessibility in the city."
    },
    {
        id: 39,
        category: 3,
        location: "Serbia",
        title: 'Morava Corridor Motorway Project',
        teaser: "Bechtel is fostering economic growth throughout Serbia with the construction of the Morava Corridor, which will connect commercial centers within Serbia and expand access to markets in Slovenia, Croatia, North Macedonia, Italy, and Romania. The motorway will also include an expansive 5G telecommunication network and a flood defense system to protect local communities."
    },
    {
        id: 40,
        category: 3,
        location: "New Delhi, India",
        title: 'Noida International Airport',
        teaser: "Bechtel is supporting Tata Projects in its delivery of India’s first net-zero emissions airport. Modern, hyper-efficient, and passenger-centric, Noida International Airport will serve New Delhi and will be India’s largest airport, with an opening capacity of 12 million passengers annually."
    },
    {
        id: 41,
        category: 4,
        location: "New Mexico, U.S.",
        title: 'Waste Isolation Pilot Plant (WIPP)',
        teaser: "The U.S. Department of Energy selected a Bechtel company to manage and operate the Waste Isolation Pilot Plant. Located in a salt formation more than 2,100 feet underground, WIPP is the world’s only operating deep geologic repository for defense nuclear waste."
    },
    {
        id: 42,
        category: 4,
        location: "Washington, U.S.",
        title: 'Hanford Waste Treatment Plant (WTP)',
        teaser: "This one-of-a-kind complex will immobilize up to 56 million gallons of waste stored in 176 aging underground tanks from World War II and the Cold War. Designed by Bechtel, the plant uses vitrification to heat radioactive waste and glass-forming materials to 2,100 degrees Fahrenheit. Once the molten material cools and solidifies into glass, it can be safely and securely disposed of, protecting the Columbia River and surrounding communities."
    },
    {
        id: 43,
        category: 4,
        location: "Hamburgo, Chile",
        title: 'Hamburgo Tailings Removal Project',
        teaser: "BHP awarded Bechtel the pre-feasibility study for the removal of the Hamburgo tailings dam, which has not been used since 2002, from the Escondida mine pit. This project is crucial for Escondida, allowing the mine to expand and process 300 metric tons in the dam."
    },
    {
        id: 44,
        category: 4,
        location: "Sellafield, U.K.",
        title: 'Pile Fuel Cladding Silo (PFCS)',
        teaser: "The Sellafield PFCS, considered to be one of the four most hazardous buildings in Western Europe and Europe’s largest nuclear site, was commissioned in 1952 to safely store radioactive material used in some of the U.K.’s earliest nuclear reactors. Bechtel Cavendish Nuclear Solutions is  delivering a system that will allow Sellafield to retrieve, package, and dispose of this waste safely and permanently."
    },
    {
        id: 45,
        category: 4,
        location: "Northern Territory, Australia",
        title: 'Ranger Mine Rehabilitation Project',
        teaser: "Bechtel is helping Energy Resource Australia manage a rehabilitation program at the Ranger uranium mine. An environmentally sensitive site located near a World Heritage-listed national park, the Ranger Mine Rehabilitation Project is a flagship initiative and a key part of the closure plan for the mine and processing plant."
    },
    {
        id: 46,
        category: 5,
        location: "Ohio, U.S.",
        title: 'Intel Semiconductor Plant Facility',
        teaser: "Bechtel is designing and building Intel’s new advanced semiconductor manufacturing facility, which will revitalize chipmaking in the U.S., restore dependability and resilience to the global semiconductor supply chain, and strengthen economic development in the region. Partnering with North America’s Building Trades Unions and suppliers, Bechtel will also create new construction jobs and implement training programs with local education organizations."
    },
    {
        id: 47,
        category: 5,
        location: "U.S.",
        title: 'Mitra Chem Cathode Manufacturing Plant',
        teaser: "Bechtel will design Mitra Chem’s commercial cathode manufacturing plant, which will produce Lithium Iron Phosphate cathodes on a commercial scale by 2025. With Bechtel’s support, Mitra Chem will be able to rapidly scale its operations and deliver on its mission to create mass-market electrification for electric vehicles, energy storage solutions, and beyond."
    },
    {
        id: 48,
        category: 5,
        location: "Manama, Bahrain",
        title: 'Alba Line 7',
        teaser: "Alba selected Bechtel to perform the feasibility study for Alba’s Line 7, exploring the sustainable expansion of one of the world’s largest aluminum smelters. Line 7 is estimated to have a production capacity of approximately 540,000 metric tons per year."
    },
    {
        id: 49,
        category: 5,
        location: "Pennsylvania, U.S.",
        title: 'Shell Polymers Monaca',
        teaser: "Bechtel completed construction of the Shell Polymers Monaca petrochemicals complex, which will produce 1.6 million tonnes of polyethylene per year for use in manufacturing a wide range of everyday products. Shell’s Monaca plant is a world-scale facility nearly a decade in the making, offering communities in the region access to job opportunities and business development."
    },
    {
        id: 50,
        category: 5,
        location: "U.S.",
        title: 'Sicona Battery Technologies Anode Manufacturing Plant',
        teaser: "Sicona Battery Technologies awarded Bechtel an engineering study for its first U.S. manufacturing plant, which will produce the cutting-edge battery anode components needed for electric vehicles. Bechtel will help Sicona optimize manufacturing area designs, design requirements, utilities, equipment, and materials."
    },
    {
        id: 51,
        category: 6,
        location: "Nevada, U.S.",
        title: 'Thacker Pass Lithium Mine',
        teaser: "Lithium Americas Corp. selected Bechtel to construct Thacker Pass Phase 1, which aims to responsibly access the critical resources needed to strengthen the country’s battery supply chain and advance decarbonization targets."
    },
    {
        id: 52,
        category: 6,
        location: "Tarapacá, Chile",
        title: 'Collahuasi Mine',
        teaser: "As the project management consultant for C20+, Bechtel is supporting expansion and efficiency improvements at one of the world’s largest copper operations. To help meet global demand and avoid tapping precious freshwater reserves, a desalination plant will transport seawater to the mine’s facilities 4,400 meters above sea level."
    },
    {
        id: 53,
        category: 6,
        location: "Victoria, Australia",
        title: 'Latrobe Magnesium Stage 3',
        teaser: "Latrobe Magnesium awarded Bechtel the pre-feasibility study for the development of its Stage 3 International Magnesium Mega Plant with an annual capacity of 100,000 tons. The lightest of all structural materials, 100% recyclable, and with the best strength-to-weight ratio of all common structural metals, magnesium is increasingly used in car parts, the aviation industry, laptop computers, mobile phones, and power tools."
    },
    {
        id: 54,
        category: 6,
        location: "Northern Highlands, Peru",
        title: 'Yanacocha Stage 3',
        teaser: "Newmont is working with Bechtel to support its Yanacocha sulfide expansion project at South America’s largest gold mine, which will extend the mine’s life beyond 2040 and enable more sustainable production."
    },
    {
        id: 55,
        category: 6,
        location: "Central Arabian Gold Region, Saudi Arabia",
        title: 'Mansourah-Massarah Gold Project',
        teaser: "Bechtel and Ma’aden achieved a major milestone with first gold at the Mansourah-Massarah Gold Project (MMGP), contributing to Saudi Arabia’s Vision 2030 strategy to create a more diverse and sustainable economy. MMGP is the largest and most technologically advanced gold mine in Saudi Arabia, capable of producing 250,000 ounces of gold per year."
    },
    {
        id: 56,
        category: 6,
        location: "Tarapacá Region, Chile",
        title: 'Quebrada Blanca Phase 2',
        teaser: "Bechtel is extending the life and increasing the output of Teck’s Quebrada Blanca copper mine, which will tap one of the world’s largest undeveloped copper resources and help to close the gap between global supply and rising demand for copper in energy transition programs. QB2 is expected to generate 316,000 tonnes of copper-equivalent production per year for the first five full years of mine life."
    },
    {
        id: 57,
        category: 6,
        location: "Coquimbo Region, Chile",
        title: 'Los Pelambres',
        teaser: "Bechtel is helping Antofagasta Minerals (AMSA) sustain Los Pelambres mine’s production level while reducing environmental impact. One of AMSA's main focuses is improving water efficiency by reducing continental water consumption and increasing seawater usage. Once finished, the mine’s water treatment facilities will filter 106 gallons (400 liters) of water per second."
    },
    {
        id: 58,
        category: 6,
        location: "Karratha, Australia",
        title: 'Parker Point Port',
        teaser: "Bechtel completed a prefeasibility study to debottleneck Rio Tinto’s Parker Point port facility, replacing critical machinery to increase the capacity and efficiency of this iron ore project."
    },
    {
        id: 59,
        category: 6,
        location: "California, U.S.",
        title: 'MP Materials Phase 2',
        teaser: "Bechtel was awarded the project management contractor role at the MP Materials project in California, the only integrated rare earth mining and processing site in North America. The site will produce critical minerals to support the energy transition and electric vehicle market."
    },
    {
        id: 60,
        category: 7,
        location: "Georgia, U.S.",
        title: 'Plant Vogtle Units 3 & 4',
        teaser: "Bechtel is building Plant Vogtle Units 3 and 4 for Georgia Power and Southern Nuclear. Units 3 and 4 are the first new nuclear units built in the U.S. in more than three decades. Nuclear power is a critical contributor to meeting net-zero goals and a strategic energy source for the U.S. given its carbon-free output and ability to provide stable baseload power. Once complete, the units will power 500,000 homes and businesses."
    },
    {
        id: 61,
        category: 7,
        location: "Wyoming, U.S.",
        title: 'Natrium',
        teaser: "Bechtel conducted geotechnical investigations and design concepts for TerraPower’s Natrium nuclear reactor. Demonstrating the next generation of clean electricity production, Natrium is designed to adapt to changes in daily electricity demands driven by solar and wind energy fluctuations. The reactor is safer, simpler, less costly to construct, and less expensive to operate, and provides energy that is competitive with fossil fuels."
    },
    {
        id: 62,
        category: 7,
        location: "Poland",
        title: 'Polish Civil Nuclear Power Program',
        teaser: "In partnership with Westinghouse Electric Company, Bechtel is helping Poland to further its energy transition goals while maintaining its energy independence and security. Bechtel, Westinghouse Electric Company, and our customer, Polskie Elektrownie Jądrowe, signed an agreement that solidifies the project team for the first AP1000 nuclear power reactors in Poland and defines the path forward for the Westinghouse-Bechtel consortium to engineer and construct three Polish nuclear reactors."
    },
];
